var render = function render() {
  var _vm$form$buttonInfo;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_vm.form.buttonInfo ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮设置")
    }
  }, _vm._l((_vm$form$buttonInfo = _vm.form.buttonInfo) === null || _vm$form$buttonInfo === void 0 ? void 0 : _vm$form$buttonInfo.buttons, function (buttonItem, idx) {
    return _c("div", {
      key: idx,
      staticClass: "buttonItem"
    }, [_c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(buttonItem.buttonFontColor, "buttonFontColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(buttonItem.buttonBgColor, "buttonBgColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("a-button", {
      attrs: {
        type: "primary"
      }
    }, [_vm._v(_vm._s(_vm.$t(buttonItem.buttonName)))])], 1)]);
  }), 0) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发票配置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("保单批量勾选数量上限")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-input", {
    staticStyle: {
      width: "138px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + "1-50"
    },
    on: {
      input: function ($event) {
        _vm.form.invoiceConfig.maxSelect = _vm.form.invoiceConfig.maxSelect.replace(/[^\d]/g, "");
      },
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.invoiceConfig.maxSelect,
      callback: function ($$v) {
        _vm.$set(_vm.form.invoiceConfig, "maxSelect", $$v);
      },
      expression: "form.invoiceConfig.maxSelect"
    }
  })], 1)])])], 1), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };